window._ = require('lodash');
window.Popper = require('popper.js').default;

if(window.isPDB !== true) {
    try {
        window.$ = window.jQuery = require('jquery');
        require('bootstrap');
    } catch (e) {
    }
}

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
